import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  template: {
    defaultMessage: 'Template',
    id: `app.containers.WorkflowEditor.components.Rules.Condition.ScoreCardResult.template`,
  },
});
